import { render, staticRenderFns } from "./EditNotificationRequest.vue?vue&type=template&id=d4932f88&v-loading=loadingNotification&"
import script from "./EditNotificationRequest.vue?vue&type=script&lang=ts&"
export * from "./EditNotificationRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports